<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">配置常用项 [ 结算表内容自定义 ]</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInUserEdit">
      <section class="searchBox">
        <span class="addStyle"> </span>
        <span>
          <label>属性名：</label>
          <div>
            <a-input
              v-model="nameSearch"
              placeholder="请输入属性名"
              style="margin-right: 20px"
            />
          </div>
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                {{ item.name }}
              </td>
              <td style="width: 40%">
                <span
                  v-show="item.fixed_data_config != ''"
                  v-for="(element, k) in item.fixed_data_config"
                  :key="k"
                >
                  <span>{{ element.name }}</span>
                  <span v-show="k < item.fixed_data_config.length - 1"
                    >&nbsp;|&nbsp;</span
                  >
                </span>
              </td>
              <td style="width: 40%">
                <span
                  v-show="item.float_data_config != ''"
                  v-for="(element, k) in item.float_data_config"
                  :key="k"
                >
                  <span>{{ element.name }}</span>
                  <span v-show="k < item.float_data_config.length - 1"
                    >&nbsp;|&nbsp;</span
                  >
                </span>
              </td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 编辑 -->
    <setOrderEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import setOrderEdit from "@/components/manpower/setOrderEdit"; //编辑
import { mapState } from "vuex";

export default {
  components: {
    setOrderEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: ["模版名称", "固定参数", "其他参数", "操作"]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "People_config/lists";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    clearSearch() {
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    span {
      display: inline-block;
      vertical-align: top;
      margin-bottom: 10px;
      margin-right: 20px;
      input,
      label,
      > div {
        display: inline-block;
        vertical-align: top;
      }
      label {
        line-height: 32px;
      }
    }
    .addStyle {
      margin-right: 30%;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
